/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import Skeleton from 'react-loading-skeleton';
import { e300 } from '@atlaskit/theme/elevation';

type Props = {}

const InvoicePreviewSkeleton: React.FC<Props> = (props) => {

  return (<div
    css={css`
              padding: 4rem;
              position: absolute;
              background: white;
              width: 21cm;
              height: 29.7cm;
            `}
  >
    <div
      css={css`text-align: right;`}
    >
      <div>
        <Skeleton
          count={1}
          height={'1.25rem'}
          width={'50%'}
          style={{ marginBottom: '2rem' }}
        />
      </div>
      <div>
        <Skeleton
          count={1}
          height={'1.25rem'}
          width={'30%'}
          style={{ marginBottom: '0.5rem' }}
        />
      </div>
      <div>
        <Skeleton
          count={1}
          height={'1.25rem'}
          width={'20%'}
          style={{ marginBottom: '0.5rem' }}
        />
      </div>
      <div>
        <Skeleton
          count={1}
          height={'1.25rem'}
          width={'25%'}
          style={{ marginBottom: '8rem' }}
        />
      </div>
    </div>
    <div>
      <div>
        {' '}
        <Skeleton
          count={1}
          height={'1.25rem'}
          width={'25%'}
          style={{ marginBottom: '4rem' }}
        />
      </div>
      <Skeleton
        count={3}
        height={'1.25rem'}
        style={{ marginBottom: '1.5rem' }}
      />
      <div
        css={css`
                  text-align: right;
                `}
      >
        <div>
          <Skeleton
            count={1}
            height={'1.25rem'}
            width={'25%'}
            style={{ marginBottom: '1rem', marginTop: '4rem' }}
          />
        </div>
        <div>
          <Skeleton
            count={1}
            height={'1.25rem'}
            width={'20%'}
            style={{ marginBottom: '4rem' }}
          />
        </div>
      </div>
      <div>
        <Skeleton
          count={1}
          height={'1.25rem'}
          width={'100%'}
          style={{ marginTop: '16rem' }}
        />
      </div>
    </div>
  </div>
);
};

export default InvoicePreviewSkeleton;
